module.exports = __webpack_public_path__ + "static/media/Jeniffer_Garcia_Martinez.44c2e14c.png";